'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _globalQueue = require('global-queue');

var _globalQueue2 = _interopRequireDefault(_globalQueue);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _default = (function () {
	function _default(opts) {
		_classCallCheck(this, _default);

		this.opts = (0, _objectAssign2['default'])({
			l: 'dataLayer'
		}, opts);

		this.requestParams = _queryString2['default'].stringify({ id: this.opts.id, l: this.opts.l });

		this.push = (0, _globalQueue2['default'])('dataLayer', { wrap: false });
		this.scripts = {
			ga: {
				url: '//www.google-analytics.com/analytics.js'
			},
			gtm: {
				url: '//www.googletagmanager.com/gtm.js?' + this.requestParams
			}
		};
	}

	_createClass(_default, [{
		key: 'script',
		value: function script(name, url, opts) {
			this.scripts[name] = { url: url, opts: opts };
			return this;
		}
	}, {
		key: 'load',
		value: function load(name) {
			var _scripts$name, url, opts;

			return regeneratorRuntime.async(function load$(context$2$0) {
				while (1) switch (context$2$0.prev = context$2$0.next) {
					case 0:
						_scripts$name = this.scripts[name];
						url = _scripts$name.url;
						opts = _scripts$name.opts;
						return context$2$0.abrupt('return', new Promise(function (resolve, reject) {
							(0, _loadScript2['default'])(url, opts, function (err, script) {
								if (err) {
									reject(err);
									return;
								}

								resolve(script);
							});
						}));

					case 4:
					case 'end':
						return context$2$0.stop();
				}
			}, null, this);
		}
	}, {
		key: 'track',
		value: function track(key, val) {
			if (!val) {
				this.push(key);
				return;
			}

			this.push(_defineProperty({}, key, val));
		}
	}, {
		key: 'getClientId',
		value: function getClientId() {
			return regeneratorRuntime.async(function getClientId$(context$2$0) {
				while (1) switch (context$2$0.prev = context$2$0.next) {
					case 0:
						return context$2$0.abrupt('return', new Promise(function (resolve, reject) {
							window.ga(function (tracker) {
								var id = tracker.get('clientId');

								if (!id) {
									reject();
								}

								resolve(id);
							});
						}));

					case 1:
					case 'end':
						return context$2$0.stop();
				}
			}, null, this);
		}
	}, {
		key: 'create',
		value: function create() {
			return regeneratorRuntime.async(function create$(context$2$0) {
				while (1) switch (context$2$0.prev = context$2$0.next) {
					case 0:
						if (window.ga) {
							context$2$0.next = 2;
							break;
						}

						return context$2$0.abrupt('return', false);

					case 2:

						window.ga('create', this.opts.gaId, 'auto');

					case 3:
					case 'end':
						return context$2$0.stop();
				}
			}, null, this);
		}
	}, {
		key: 'start',
		value: function start() {
			return regeneratorRuntime.async(function start$(context$2$0) {
				var _this = this;

				while (1) switch (context$2$0.prev = context$2$0.next) {
					case 0:
						this.push({ 'gtm.start': Number(new Date()), event: 'gtm.js' });

						return context$2$0.abrupt('return', Promise.all([this.load('gtm'), this.load('ga')]).then(function () {
							return _this.create();
						}));

					case 2:
					case 'end':
						return context$2$0.stop();
				}
			}, null, this);
		}
	}]);

	return _default;
})();

exports['default'] = _default;
module.exports = exports['default'];